module.exports = __webpack_public_path__ + "img/2-4.ebb5d7fe.svg";